import { useTranslation } from 'react-i18next';

import type { IncidentCommand, IncidentCommandAction } from '@ngsos/portal-core/commands';

import { PanelErrorWithIcon } from '@/ui';
import { LoadingRetryButton } from '@/ui/loading/LoadingRetryButton';
import { IncidentOperationProgress } from './IncidentOperationProgress';

export type IncidentCommandFeedbackProps = {
  action: IncidentCommandAction;
  command: IncidentCommand;
  compact?: boolean;
  allowRetry?: boolean;
  onRetry?: () => Promise<void>;
  progressTestID?: string;
  errorTestID?: string;
};

export function IncidentCommandFeedback({
  action,
  command,
  compact,
  allowRetry = true,
  onRetry,
  progressTestID,
  errorTestID,
}: IncidentCommandFeedbackProps) {
  const { t } = useTranslation();

  if (command.status === 'idle') {
    return null;
  }

  if (command.status === 'pending') {
    return <IncidentOperationProgress operation={action} compact={compact} testID={progressTestID} />;
  }

  const retry = async () => {
    if (onRetry !== undefined) {
      await onRetry();
    } else {
      await command.start();
    }
  };

  return (
    <div className="p-3 operation-feedback" role="alert" data-testid={errorTestID}>
      <PanelErrorWithIcon title={t('Global_ActionFailed')} centerContent />
      <div className="text-center mt-3">{allowRetry ? <LoadingRetryButton onRetry={retry} size="small" /> : null}</div>
    </div>
  );
}
